
<template>
  <vs-popup popup-class="w-11/12" :title="title" :active.sync="popupActive">
    <form>
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-col w-full">
            <div class="mt-4 mb-3" style="font-size: 0.8rem">نوع درگاه:</div>
          </div>
          <vs-radio
            v-for="item in Object.values(DraftType).filter((x) => x.succeeding)"
            :key="item.name"
            :vs-value="item.value"
            v-model="draft.draftType"
            class="mr-4 w-full"
            vs-name="layout-type-vertical"
          >
            <span style="vertical-align: middle">
              <feather-icon
                :title="item.title"
                :icon="item.icon"
                :svgClasses="[`h-5 w-6 stroke-current `]"
                style="vertical-align: middle"
              ></feather-icon>
            </span>
            {{ item.title }}
          </vs-radio>
        </div>
        <div class="vx-col w-full mt-5">
          <bcs v-model="draft.businessCategoryId" />
        </div>
        <div class="vx-col w-full">
          <vs-input
            label="نام درگاه"
            v-validate="{ required: true }"
            name="farsiName"
            v-model="draft.shopName"
            class="w-full mt-4"
          />
          <span class="text-danger text-sm" v-show="errors.has('farsiName')"
            >نام را وارد کنید</span
          >
        </div>
        <div class="vx-col w-full">
          <vs-input
            label="وبسایت"
            v-validate="{
              regex:
                '^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?',
            }"
            name="websiteAddress"
            v-model="draft.websiteAddress"
            class="w-full mt-4 ltr-input"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('websiteAddress')"
            >آدرس وبسایت را درست وارد کنید</span
          >
        </div>
        <div class="vx-col w-full mt-4">
          <vs-button
            @click.prevent="submitForm"
            color="primary"
            type="filled"
            >{{
              createEditMode == CreateEditMode.Edit ? "ذخیره" : "ثبت درخواست"
            }}</vs-button
          >
        </div>
      </div>
    </form>
  </vs-popup>
</template>
<style>
</style>
<script>
import { CreateEditMode, DraftType } from "@/enums.js";
export default {
  name: "gateway-create-or-edit",
  props: {},
  data() {
    return {
      DraftType,
      popupActive: false,
      draftId: "",
      shopName: "",
      CreateEditMode,
      createEditMode: CreateEditMode.Create,
      draft: {},
    };
  },
  computed: {
    title() {
      return this.shopName
        ? `ویرایش درخواست "${this.shopName}"`
        : "درخواست جدید";
    },
  },
  methods: {
    show(shopName = "", draftId = null) {
      this.popupActive = true;
      this.draftId = draftId;
      this.shopName = shopName;
      this.draft = { draftType: 1 };
      if (draftId) {
        this.getDraft();
        this.createEditMode = this.CreateEditMode.Edit;
      } else {
        this.createEditMode = this.CreateEditMode.Create;
      }
    },
    getDraft() {
      let payload = {
        params: {
          id: this.draftId,
        },
      };
      let loading = this.$vs.loading();
      let path = "";
      if (this.$route.query.mid) {
        path = "/api/services/app/Gateway/GetRequestGateway";
      } else {
        path = "/api/services/app/Gateway/GetRequestGateway_CurrentUser";
      }
      this.$http
        .get(path, payload)
        .then((response) => {
          console.log(response);
          this.draft = response.data.result;
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    submitForm() {
      if (!this.draft.businessCategoryId) {
        this.$vs.notify({
          time: 5000,
          color: "warning",
          title: "نقص اطلاعات!",
          text: "صنف را انتخاب کنید",
        });
        return;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createOrEdit();
        } else {
          this.$vs.notify({
            time: 5000,
            color: "warning",
            title: "نقص اطلاعات!",
            text: "داده‌های خواسته شده را صحیح وارد کنید",
          });
        }
      });
    },
    createOrEdit() {
      let loading = this.$vs.loading();
      let path = "";
      if (this.$route.query.mid) {
        path =
          this.createEditMode == this.CreateEditMode.Create
            ? "/api/services/app/Gateway/RequestNewGatewaySimple"
            : "/api/services/app/Gateway/RequestEditGatewaySimple";
        this.draft.merchantId = this.$route.query.mid;
      } else {
        path =
          this.createEditMode == this.CreateEditMode.Create
            ? "/api/services/app/Gateway/RequestNewGatewaySimple_CurrentUser"
            : "/api/services/app/Gateway/RequestEditGatewaySimple_CurrentUser";
      }
      this.$http
        .post(path, this.draft)
        .then((response) => {
          console.log(response);
          if (response.data.success) {
            this.popupActive = false;
            this.$emit("success");
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: `درخواست با موفقیت ذخیره شد.`,
            });
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
  },
};
</script>